type ModalTitleProps = {
  children: React.ReactNode;
};

export const ModalTitle = ({ children }: ModalTitleProps): JSX.Element => {
  return <h1 className="core-modal-v2-title__text">{children}</h1>;
};
